export default class PlanInformation {
  name: string;
  benefits?: string;
  hios_id: string;
  product_type: string;
  plan_year: string;
}
